import CityPageTemplate from "../city-template/CityPageTemplate";
import { irvingConfig } from "./data";

export default function IrvingPage() {
  return <CityPageTemplate config={irvingConfig} />;
}